import React, { useEffect, useState } from "react";
import _ from "lodash";
import { GithubPicker } from 'react-color';
import { message,Popover } from "antd";

const ColorSelect = (props) => {
    const { value = "#108ee9", onChange } = props;


    useEffect(()=>{
  },[]);

  const content = (
    <GithubPicker onChangeComplete={(color)=>{
      onChange(color.hex);
    }} styles={{'default':{ card: {
      border: 'none', // 移除边框
      boxShadow: 'none',
      padding: 0, // 移除 padding
      
    }}}} triangle={"hide"} />
  );

    return (<Popover trigger="click" content={content}>
      <div style={{ backgroundColor: value }} className={`min-w-16 rounded flex-none`}>&nbsp;</div>
  </Popover>);
}

export default ColorSelect;